import { render } from "./SchemaComment.vue?vue&type=template&id=13432d75"
import script from "./SchemaComment.vue?vue&type=script&lang=js"
export * from "./SchemaComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__